import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import { User } from '../';
import { SessionStorageService } from '../../core/services';

@Injectable()
export class UserService {
    // Observable User source
    private userDataChangedSource = new Subject<User>();

    // Observable User streams
    userDataChanged$ = this.userDataChangedSource.asObservable();

    constructor(
        private sessionStorageService: SessionStorageService
    ) {}
    
    getUserSessionData(): User {
        return this.sessionStorageService.getData<User>('eca-user');
    }

    setUserSessionData(user: User): boolean {
        return this.sessionStorageService.setData('eca-user', user);
    }

    clearUserSessionData(): boolean {
        return this.sessionStorageService.removeData('eca-user');
    }

    userDataChanged(user: User) {
        this.userDataChangedSource.next(user);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/services/UserService.ts